module.exports = __webpack_public_path__ + "img/id4.ee107e8a.png";